import {computed} from 'vue';
import {useSiteProvider} from "@/helpers/site";
import {usePermissionProvider, useUserProvider} from "@/helpers/user/index";


const useAuthContext = () => {
  const {selectedSiteId} = useSiteProvider();
  const {currentUser} = useUserProvider();
  const {permissions} = usePermissionProvider();

  const currentUserPermissions = computed(() => {
    const siteId = (selectedSiteId.value || '').toString();
    const userRoles = new Set(currentUser.value?.roles || []);

    return Object.freeze(
      new Set(
        permissions.value
          .filter(permission => permission.siteId === siteId)
          .flatMap(({permissionCategories}) =>
            (permissionCategories || [])
              .flatMap(({keyword: category, permissionDetails}) =>
                (permissionDetails || [])
                  .flatMap(({keyword: detail, roleIds}) =>
                    roleIds
                      .filter(roleId => userRoles.has(roleId))
                      .map(() => category + '.' + detail)
                  )
              )
          )
      )
    );
  });

  return {
    currentUser,
    currentUserPermissions
  };
};

export default useAuthContext;
